import React from 'react'
import { observer } from 'mobx-react-lite'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { ConnectDrawer, useFinstrongStore, useGlobalCopyStore } from '../../../common'
import TotalCard from '../shared/TotalCard'
import Transactions from '../shared/Transactions'

const IncomeTabContent: React.FC = () => {
  const { healthScore, allTransactions } = useFinstrongStore()
  const { connect: connectCopy, finstrong: copy } = useGlobalCopyStore()
  const [showConnectWidget, setShowConnectWidget] = React.useState(false)

  return (
    <Stack gap={16} sx={{ p: 16 }}>
      <TotalCard
        balance={healthScore.ninety_day_income}
        sx={{ flexDirection: 'column-reverse' }}
        title={copy.key_indicators_borrow.have_manageable_debt_drawer.have_manageable_debt_income}
      />

      {allTransactions.income.length ? (
        // TODO: Need to add More Transactions functionality
        <Transactions transactions={allTransactions.income.map((item) => item.transaction)} />
      ) : (
        <Button
          onClick={() => {
            setShowConnectWidget(true)
          }}
          variant="contained"
        >
          {copy.connect_more_accounts_button}
        </Button>
      )}

      <ConnectDrawer
        onClose={() => setShowConnectWidget(false)}
        showConnectWidget={showConnectWidget}
        title={connectCopy.mini_title}
      />
    </Stack>
  )
}

export default observer(IncomeTabContent)
